import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const CostNoItSupport3 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="costNoItSupport" section="directCosts">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="costNoItSupport:directCosts" noGroupTitle tag="h3" first noPadBottom />
        </div>
    </ServiceSection>
);

export default CostNoItSupport3;
